import React from 'react';
import Skeleton from 'react-loading-skeleton';
import moment from 'moment';
import Image from 'next/image';

import Checkers from '../../../../helpers/class/Checkers';
import ViewPort from '../../../ViewPort';
import Link from "next/link";

export default function TilesType ( props ) {

  const builder = props.builder;
  const content = props.content;
  const articles = props.articles;

  let container_class = 'container';
  if ( props.type == 'blog' && Checkers.isValidString( builder.builder_news_view_width ) ) {
    container_class = builder.builder_news_view_width;
  } else if ( props.type == 'category' && Checkers.isValidString( content.category_view_width ) ) {
    container_class = content.category_view_width;
  }

  let row_class = ' p-0 ';
  if (props.type == 'blog') {
    if (Checkers.isValidString(builder.builder_news_view_width)) {
      container_class = builder.builder_news_view_width;
    }
    row_class += " " + Checkers.isValidObjString(builder, 'builder_news_radius') ? ` border-radius-${builder.builder_news_radius}\  ` : '';
    row_class += " " + Checkers.isValidObjString(builder, 'builder_news_shadow') ? ` shadow-${builder.builder_news_shadow} ` : '';

  } else if (props.type == 'category') {
    if (Checkers.isValidString(content.category_view_width)) {
      container_class = content.category_view_width;
    }
    row_class += " " + Checkers.isValidObjString(content, 'tiles_radius') ? ` border-radius-${content.tiles_radius}` : '';
    row_class += " " + Checkers.isValidObjString(content, 'tiles_shadow') ? ` shadow-${content.tiles_shadow}` : '';

  }

  const TileDiv = ( article, created, classNamesFromOptions, col_class, height ) =>
    <ViewPort
      parentClassName={col_class}
      skeletonItem={
        <Skeleton height={height} width={'100%'}/>
      }
    >
      <div key={article.id.toString()}  className={col_class} style={{overflow: "hidden"}}>
        <div className={'m-b-10 m-r-10'}>
          <Link href={props.updateHref( article )}>
            <a  className={props.setClass( article, classNamesFromOptions.join( ' ' ) ) + ' ' + (Checkers.isValidString(props.itemClassName) ? props.itemClassName : '') + ' '  + row_class}
                onClick={() => props.clickHandler( article )}
               onMouseEnter={( event ) => props.updateHref( event, article )}
               style={{cursor: article.has_description == "1" ? 'pointer' : null}}
            >
              <div className="col-12 p-0 col-photo-tile">
                {
                    Checkers.isValidString( article.image ) &&
                    <Image
                        layout={'responsive'}
                        width={300}
                        height={300}
                        sizes={'75vw'}
                        quality={'75'}
                        src={article.image}
                        alt={'Post Img'}
                        placeholder={'blur'}
                        blurDataURL={'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                    />
                }
              </div>
              <div className="col-12">
                <div className="d-flex flex-column h-100 py-4">
                  <div className="text-uppercase hint-text fw-bold small-text text-master text-design-color">
                    {props.articlesContentType == 'blog' ? created : article.title}
                  </div>
                  <p className="text-master bold m-b-0 line-clamp-1">{props.articlesContentType == 'blog' ? article.title : props.articlesContentType == 'category' ? article.description : article.subtitle}</p>
                </div>
              </div>
            </a>
          </Link>
        </div>
      </div>
    </ViewPort>
    ;

  const SkeletonTileDiv = ( i, col_class, height ) =>
    <div key={i.toString()} className={col_class}>
      <Skeleton height={height} width={'100%'}/>
    </div>

  //------------------------ DEVIDE THE ARRAY OF DIVS FOR THE ORDER ----------------------------------
  //------------------------ etc LEFT = [0,3,4,6], RIGHT = [1,2,5,7,8] -------------------------------
  let pointer = "left"; // left right

  let items_left = 1;
  let left_start_pos = 1;

  let items_right = 2;
  let right_start_pos = 2;

  const array_left = [];
  const array_right = [];

  const skeleton_array_left = [];
  const skeleton_array_right = [];

  for ( let i = 0; i < 6; i++ ) {
    let key = i;
    const classNamesFromOptions = [];
    classNamesFromOptions.push( 'row w-100 m-0 bg-white' );
    if ( Checkers.isValidObjString( builder, 'builder_news_radius' ) ) {
      classNamesFromOptions.push( `border-radius-${builder.builder_news_radius}` )
    }
    if ( Checkers.isValidObjString( builder, 'builder_news_shadow' ) ) {
      classNamesFromOptions.push( `shadow-${builder.builder_news_shadow}` )
    }

    if ( pointer=="left" ) {
      if ( ( key+1 ) == articles.length && left_start_pos == 2 ) {
        if ( right_start_pos == 2 ) {
          skeleton_array_left.push( SkeletonTileDiv( i, 'col-12 col-sm-12 col-md-6 mb-4', 385 ) );
        } else {
          skeleton_array_right.push( SkeletonTileDiv( i, 'col-12 col-sm-12 col-md-12 mb-4', 703 ) );
        }
      } else {
        skeleton_array_left.push( SkeletonTileDiv( i, left_start_pos == 1 ? 'col-12 col-sm-12 col-md-12 mb-4' : 'col-6 col-sm-6 col-md-6 mb-4', left_start_pos  == 1 ? 730 : 385 ) );
      }
      items_left -= 1;
      if ( items_left==0 ) {
        pointer = "right";
        if ( left_start_pos==1 ) {
          left_start_pos = 2;
        } else {
          left_start_pos = 1;
        }
      }
      items_right = right_start_pos;

    } else if ( pointer=="right" ) {
      if ( ( key+1 ) == articles.length && right_start_pos == 2 ) {
        if ( left_start_pos == 2 ) {
          skeleton_array_right.push( SkeletonTileDiv( i, 'col-12 col-sm-12 col-md-6 mb-4', 385 ) );
        } else {
          skeleton_array_left.push( SkeletonTileDiv( i, 'col-12 col-sm-12 col-md-12 mb-4', 703 ) );
        }
      } else {
        skeleton_array_right.push( SkeletonTileDiv( i, right_start_pos == 1 ? 'col-12 col-sm-12 col-md-12 mb-4' : 'col-6 col-sm-6 col-md-6 mb-4', right_start_pos  == 1 ? 730 : 385 ) );
      }
      items_right -= 1;
      if ( items_right==0 ) {
        pointer = "left";
        if ( right_start_pos==1 ) {
          right_start_pos = 2;
        } else {
          right_start_pos = 1;
        }
      }
      items_left = left_start_pos;
    }
  }

  articles.map( ( article, key ) => {
    if ( key === 0 ) {
      pointer = "left"; // left right

      items_left = 1;
      left_start_pos = 1;

      items_right = 2;
      right_start_pos = 2;
    }
    const classNamesFromOptions = [];
    classNamesFromOptions.push( 'row w-100 m-0 bg-white' );
    if ( Checkers.isValidObjString( builder, 'builder_news_radius' ) ) {
      classNamesFromOptions.push( `border-radius-${builder.builder_news_radius}` )
    }
    if ( Checkers.isValidObjString( builder, 'builder_news_shadow' ) ) {
      classNamesFromOptions.push( `shadow-${builder.builder_news_shadow}` )
    }
    const created =
            moment( new Date( ( article.created ) * 1000 ) ).format( 'dddd Do MMMM' )
        ;

    if ( pointer=="left" ) {
      if ( ( key+1 ) == articles.length && left_start_pos == 2 ) {
        if ( right_start_pos == 2 ) {
          array_left.push( TileDiv( article, created, classNamesFromOptions, 'col-12 col-sm-12 col-md-6 mb-4', 385 ) );
        } else {
          array_right.push( TileDiv( article, created, classNamesFromOptions, 'col-12 col-sm-12 col-md-12 mb-4', 703 ) );
        }
      } else {
        array_left.push( TileDiv( article, created, classNamesFromOptions, left_start_pos == 1 ? 'col-12 col-sm-12 col-md-12 mb-4' : 'col-6 col-sm-6 col-md-6 mb-4', left_start_pos  == 1 ? 730 : 385 ) );
      }
      items_left -= 1;
      if ( items_left==0 ) {
        pointer = "right";
        if ( left_start_pos==1 ) {
          left_start_pos = 2;
        } else {
          left_start_pos = 1;
        }
      }
      items_right = right_start_pos;

    } else if ( pointer=="right" ) {
      if ( ( key+1 ) == articles.length && right_start_pos == 2 ) {
        if ( left_start_pos == 2 ) {
          array_right.push( TileDiv( article, created, classNamesFromOptions, 'col-12 col-sm-12 col-md-6 mb-4', 385 ) );
        } else {
          array_left.push( TileDiv( article, created, classNamesFromOptions, 'col-12 col-sm-12 col-md-12 mb-4', 703 ) );
        }
      } else {
        array_right.push( TileDiv( article, created, classNamesFromOptions, right_start_pos == 1 ? 'col-12 col-sm-12 col-md-12 mb-4' : 'col-6 col-sm-6 col-md-6 mb-4', right_start_pos  == 1 ? 730 : 385 ) );
      }
      items_right -= 1;
      if ( items_right==0 ) {
        pointer = "left";
        if ( right_start_pos==1 ) {
          right_start_pos = 2;
        } else {
          right_start_pos = 1;
        }
      }
      items_left = left_start_pos;
    }
  });

  return (
    <div className={`${container_class} pb-5`}>
      <div className="row w-100 m-0">
        <div className="col-12">
          <div className="row w-100 m-0">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <div className="row">
                {props.loadingArticles ?
                  skeleton_array_left.map( ( element ) => element )
                  : array_left.map( ( element ) => element )
                }
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <div className="row">
                {props.loadingArticles ?
                  skeleton_array_right.map( ( element ) => element )
                  : array_right.map( ( element ) => element )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
